import { Component, Input, OnInit } from '@angular/core';
import { CredentialService } from '@fry/lib/auth';
import {
  ApiCredential,
  LocalCredential,
  ProxyCredential
} from "@fry/lib/auth/account/credential/credential";

@Component({
    selector: 'eas-user-login',
    templateUrl: './user-login.component.html',
    standalone: false
})
export class UserLoginComponent implements OnInit {
  @Input() accountId: string = '';

  credentials$: (LocalCredential | ProxyCredential | ApiCredential)[] = [];
  allowed = false;

  constructor(
    private credentialService: CredentialService,
  ) {}

  ngOnInit() {
    this.update();
  }

  update() {
    this.credentialService.getCredentials(this.accountId).subscribe((credentials) => {
      this.credentials$ = credentials;
    });
  }
}
